import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EvaluationsModel } from './EvaluationsModel';

@Injectable({
  providedIn: 'root'
})
export class EvaluationEventService {

  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

  

 GetAllByEventId(EventId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Evaluation/GetAllByEventId/${EventId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

insert(payload: EvaluationsModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}Evaluation/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
}
